<template>
  <NodeViewWrapper
    class="inline user-mention-wrap"
    :class="{ 'ProseMirror-selectednode': selected }"
  >
    <MentionComponent
      v-if="node.attrs.userId"
      v-bind="node.attrs"
    />
  </NodeViewWrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';
import MentionComponent from './UserMention.vue';

export default {
  name: 'MentionNode',

  components: {
    NodeViewWrapper,
    MentionComponent,
  },

  props: nodeViewProps,
};
</script>
